const messages = {
  en: {
    faqs: {
      helpful: 'Was this FAQ helpful?'
    },
    tutorials: {
      helpful: 'Was this Tutorial helpful?'
    },
    landing: {
      helpful: 'Was this answer helpful?'
    },
    thanks: 'Thanks!'
  },
  'es-ud': {
    landing: {
      helpful: '¿Fue útil esta ayuda?'
    },
    tutorials: {
      helpful: 'Was this Tutorial helpful?'
    },
    faqs: {
      helpful: '¿Fue útil esta ayuda?'
    },
    thanks: '¡Gracias!'
  },
  es: {
    landing: {
      helpful: '¿Fue útil esta ayuda?'
    },
    tutorials: {
      helpful: 'Was this Tutorial helpful?'
    },
    faqs: {
      helpful: '¿Fue útil esta ayuda?'
    },
    thanks: '¡Gracias!'
  }
}

export default messages



// WEBPACK FOOTER //
// ./src/components/QuickFeedback/messages.js